import { render, staticRenderFns } from "./clothesListItem.vue?vue&type=template&id=2eeca2e0&scoped=true&"
import script from "./clothesListItem.vue?vue&type=script&lang=js&"
export * from "./clothesListItem.vue?vue&type=script&lang=js&"
import style0 from "./clothesListItem.vue?vue&type=style&index=0&id=2eeca2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeca2e0",
  null
  
)

export default component.exports